import { apiClient } from "@/services/api";


const state = () => ({
    configTarja: null,
    producaoConfigsCoresTarja: null
})

const getters = {
    getterConfigTarja: state => {
        return state.configTarja;
    },
    getterProducaoConfigCoresTarja: state => {
        return state.producaoConfigsCoresTarja
    }
}


const actions = {
    async getConfigTarja({ commit }, payload) {
        const { cod_producao } = payload;
        const response = await apiClient.get(`/getProducaoConfigTarja/${cod_producao}`)
        if(response.data) {
            commit('setConfigTarja', response.data.config)
        }
    },
    async getProducaoConfigsCoresTarja({ commit }, payload) {
        const { cod_producao } = payload;
        const response = await apiClient.get(`/getProducaoConfigCoresTarja/${cod_producao}`)
        if(response.data) {
            commit('setProducaoConfigCoresTarja', response.data.config_cores);
        }
    }
}

const mutations = {
    setConfigTarja(state, payload) {
        state.configTarja = payload
    },
    setProducaoConfigCoresTarja(state, payload) {
        state.producaoConfigsCoresTarja = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};